import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [VIEW_TECH_PLAN, VIEW_TECH_PLAN_SUCCESS, VIEW_TECH_PLAN_FAILURE] =
  createRequestActionTypes('chance/VIEW_TECH_PLAN');
export const viewTechPlan = createAction(VIEW_TECH_PLAN, (id) => id);
const viewTechPlanSaga = createRequestSaga(VIEW_TECH_PLAN, techApi.getTechPlanById);

const UNLOAD_TECH_PLAN = 'chance/UNLOAD_TECH_PLAN';
export const unloadTechPlan = createAction(UNLOAD_TECH_PLAN);

const SET_TECH_PLAN = 'chance/SET_TECH_PLAN';
export const setTechPlan = createAction(SET_TECH_PLAN, (techPlan) => techPlan);


export function* techPlanSaga() {
  yield takeLatest(VIEW_TECH_PLAN, viewTechPlanSaga);
}

const initialState = {
  techPlan: null,
  error: null,
};

const techPlan = handleActions(
  {
    [VIEW_TECH_PLAN_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techPlan: data.info,
    }),
    [VIEW_TECH_PLAN_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error,
    }),
    [UNLOAD_TECH_PLAN]: () => initialState,
    [SET_TECH_PLAN]: (state, { payload: data }) => ({
      ...state,
      techPlan: data,
    }),

  },
  initialState,
);

export default techPlan;
